import { format } from 'date-fns'

import { AreaCode } from '@enechain/eposition-proto/bfftypes/v1/area_pb'
import {
  DeliveryHourType,
  DeliveryPeriodType,
} from '@enechain/eposition-proto/types/v1/deal_pb'

export function formatPeriod(
  range: {
    deliveryStartDate?: Date
    deliveryEndDate?: Date
  },
  periodType: DeliveryPeriodType,
): string {
  const { deliveryStartDate, deliveryEndDate } = range
  if (deliveryStartDate === undefined) {
    return ''
  }
  const yearShortStart = format(deliveryStartDate, 'yy')
  const yearShortEnd =
    deliveryEndDate !== undefined ? format(deliveryEndDate, 'yy') : ''

  switch (periodType) {
    case DeliveryPeriodType.MONTH:
      return `${format(deliveryStartDate, 'MMM')}${yearShortStart}`
    case DeliveryPeriodType.MULTI_MONTH: {
      if (deliveryEndDate === undefined) {
        return ''
      }
      return `${format(deliveryStartDate, 'MMM')}${yearShortStart}-${format(deliveryEndDate, 'MMM')}${yearShortEnd}`
    }
    case DeliveryPeriodType.QUARTER: {
      // Q1＝1～3月,Q2＝4～6月,Q3＝7～9月,Q4＝10～12月
      const quarter = Math.floor(deliveryStartDate.getMonth() / 3) + 1
      return `Q${quarter}-${yearShortStart}`
    }
    case DeliveryPeriodType.SEASON: {
      // Summer=4～9月(=Q2+Q3),Winter=10-3月(=Q4+Q1翌年)
      const month = deliveryStartDate.getMonth() + 1

      if (month === 4) {
        return `Sum${yearShortStart}`
      }

      if (month === 10) {
        return `Win${yearShortStart}`
      }

      return ''
    }
    case DeliveryPeriodType.FISCAL_YEAR:
      return `FY${yearShortStart}`
    default:
      return ''
  }
}

/**
 * https://www.notion.so/enechain/c0c3a5c61c464c69be37c52cb1c56648?source=copy_link#945066db0fec46619c67bbf16843bfc5
 */
export function formatAreaAndHour(
  areaCode: AreaCode,
  hourType: DeliveryHourType,
): string {
  switch (areaCode) {
    case AreaCode.HOKKAIDO:
      if (hourType === DeliveryHourType.BASE) {
        return 'Hokkaido Base'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'Hokkaido Peak'
      }
      break
    case AreaCode.TOHOKU:
      if (hourType === DeliveryHourType.BASE) {
        return 'Tohoku Base'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'Tohoku Peak'
      }
      break
    case AreaCode.TOKYO:
      if (hourType === DeliveryHourType.BASE) {
        return 'TBL'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'TPK'
      }
      break
    case AreaCode.CHUBU:
      if (hourType === DeliveryHourType.BASE) {
        return 'CBL'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'CPK'
      }
      break
    case AreaCode.HOKURIKU:
      if (hourType === DeliveryHourType.BASE) {
        return 'Hokuriku Base'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'Hokuriku Peak'
      }
      break
    case AreaCode.KANSAI:
      if (hourType === DeliveryHourType.BASE) {
        return 'KBL'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'KPK'
      }
      break
    case AreaCode.CHUGOKU:
      if (hourType === DeliveryHourType.BASE) {
        return 'Chugoku Base'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'Chugoku Peak'
      }
      break
    case AreaCode.SHIKOKU:
      if (hourType === DeliveryHourType.BASE) {
        return 'Shikoku Base'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'Shikoku Peak'
      }
      break
    case AreaCode.KYUSHU:
      if (hourType === DeliveryHourType.BASE) {
        return 'Kyushu Base'
      }
      if (hourType === DeliveryHourType.PEAK) {
        return 'Kyushu Peak'
      }
      break
    default:
      return ''
  }

  return ''
}
